export const DISCOUNT_LINE = "discount-line";
export const DEFAULT_DISCOUNT_LINE = "discount-line-l2";
